import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RuleDetails } from '../../../recongition-system-api/model';

@Component({
  selector: 'app-measurements-panel',
  standalone: true,
  imports: [CommonModule, MatDividerModule, MatIconModule],
  templateUrl: './measurements-panel.component.html',
  styleUrl: './measurements-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementsPanelComponent {
  @Input() rules: RuleDetails[] = [];
  @Input() veredict: boolean | null = null;
}
